(function (factory) {
var elo = factory(window);
if (typeof exports === 'object') {
exports = elo;
}
}(function (win) {
var elo = (win ? win.elo : false) || elo || {};
elo.locale = elo.locale || {};
elo.locale.localeMap = elo.locale.localeMap || {};
elo.locale.localeMap["de"] = elo.locale.localeMap["de"] || {};
elo.locale.localeMap["de"]["APP.NAME"] = "ELO Export Viewer";
elo.locale.localeMap["de"]["APP.XDATE"] = "Datum";
elo.locale.localeMap["de"]["APP.IDATE"] = "Ablagedatum";
elo.locale.localeMap["de"]["APP.EXT"] = "Dateierweiterung";
elo.locale.localeMap["de"]["APP.EMPTYTEXT"] = "Wählen Sie einen Eintrag auf der linken Seite aus.";
elo.locale.localeMap["de"]["APP.DOCUMENT"] = "Dokument";
elo.locale.localeMap["de"]["APP.KEYWORDING"] = "Metadaten";
elo.locale.localeMap["de"]["APP.NODISPLAYTEXT"] = "Dieser Dokumenttyp kann nicht im Browser angezeigt werden, bitte verwenden Sie die Funktion [Speichern unter].";
elo.locale.localeMap["de"]["APP.TREE"] = "Baum";
elo.locale.localeMap["de"]["APP.SEARCH"] = "Suche";
elo.locale.localeMap["de"]["APP.SEARCHFORENTRY"] = "Einträge durchsuchen";
elo.locale.localeMap["de"]["APP.COLUMNLABELNAME"] = "Name";
elo.locale.localeMap["de"]["APP.COLUMNLABELEXT"] = "Typ";
elo.locale.localeMap["de"]["APP.COLUMNLABELHIT"] = "Treffer";
elo.locale.localeMap["de"]["APP.SAVEFILE"] = "Speichern unter";
elo.locale.localeMap["de"]["APP.DESC"] = "Zusatztext";
elo.locale.localeMap["de"]["APP.OWNER"] = "Abgelegt von";
elo.locale.localeMap["de"]["APP.LEFTCONTAINERTITLE"] = "Export";
elo.locale.localeMap["de"]["APP.LEFTCONTAINERSUBTITLE"] = "Navigation";
elo.locale.localeMap["de"]["APP.RIGHTCONTAINERSUBTITLE"] = "Vorschau";
elo.locale.localeMap["de"]["APP.GOTO"] = "Gehe zu";
elo.locale.localeMap["en"] = elo.locale.localeMap["en"] || {};
elo.locale.localeMap["en"]["APP.NAME"] = "ELO Export Viewer";
elo.locale.localeMap["en"]["APP.XDATE"] = "Date";
elo.locale.localeMap["en"]["APP.IDATE"] = "Filing date";
elo.locale.localeMap["en"]["APP.EXT"] = "File extension";
elo.locale.localeMap["en"]["APP.EMPTYTEXT"] = "Select an entry on the left side.";
elo.locale.localeMap["en"]["APP.DOCUMENT"] = "Document";
elo.locale.localeMap["en"]["APP.KEYWORDING"] = "Metadata";
elo.locale.localeMap["en"]["APP.NODISPLAYTEXT"] = "This document type cannot be displayed in the browser. Please use the function [Save as].";
elo.locale.localeMap["en"]["APP.TREE"] = "Tree";
elo.locale.localeMap["en"]["APP.SEARCH"] = "Search";
elo.locale.localeMap["en"]["APP.SEARCHFORENTRY"] = "Search entries";
elo.locale.localeMap["en"]["APP.COLUMNLABELNAME"] = "Name";
elo.locale.localeMap["en"]["APP.COLUMNLABELEXT"] = "Type";
elo.locale.localeMap["en"]["APP.COLUMNLABELHIT"] = "Hits";
elo.locale.localeMap["en"]["APP.SAVEFILE"] = "Save as";
elo.locale.localeMap["en"]["APP.DESC"] = "Extra text";
elo.locale.localeMap["en"]["APP.OWNER"] = "Filed by";
elo.locale.localeMap["en"]["APP.LEFTCONTAINERTITLE"] = "Export";
elo.locale.localeMap["en"]["APP.LEFTCONTAINERSUBTITLE"] = "Navigation";
elo.locale.localeMap["en"]["APP.RIGHTCONTAINERSUBTITLE"] = "Preview";
elo.locale.localeMap["en"]["APP.GOTO"] = "Go to";
elo.locale.localeMap["fr"] = elo.locale.localeMap["fr"] || {};
elo.locale.localeMap["fr"]["APP.NAME"] = "ELO Export Viewer";
elo.locale.localeMap["fr"]["APP.XDATE"] = "Date";
elo.locale.localeMap["fr"]["APP.IDATE"] = "Date de d\u00E9p\u00F4t";
elo.locale.localeMap["fr"]["APP.EXT"] = "Extension de fichier";
elo.locale.localeMap["fr"]["APP.EMPTYTEXT"] = "Veuillez s\u00E9lectionner une entr\u00E9e \u00E0 gauche.";
elo.locale.localeMap["fr"]["APP.DOCUMENT"] = "Document";
elo.locale.localeMap["fr"]["APP.KEYWORDING"] = "M\u00E9tadonn\u00E9es";
elo.locale.localeMap["fr"]["APP.NODISPLAYTEXT"] = "Ce type de document ne peut pas \u00EAtre affich\u00E9 dans le navigateur, veuillez utiliser la fonction [Enregistrer sous].";
elo.locale.localeMap["fr"]["APP.TREE"] = "Arborescence";
elo.locale.localeMap["fr"]["APP.SEARCH"] = "Recherche";
elo.locale.localeMap["fr"]["APP.SEARCHFORENTRY"] = "Parcourir les entr\u00E9es";
elo.locale.localeMap["fr"]["APP.COLUMNLABELNAME"] = "Nom";
elo.locale.localeMap["fr"]["APP.COLUMNLABELEXT"] = "Type";
elo.locale.localeMap["fr"]["APP.COLUMNLABELHIT"] = "R\u00E9sultats";
elo.locale.localeMap["fr"]["APP.SAVEFILE"] = "Enregistrer sous";
elo.locale.localeMap["fr"]["APP.DESC"] = "Texte suppl\u00E9mentaire";
elo.locale.localeMap["fr"]["APP.OWNER"] = "D\u00E9pos\u00E9 par";
elo.locale.localeMap["fr"]["APP.LEFTCONTAINERTITLE"] = "Exportation...";
elo.locale.localeMap["fr"]["APP.LEFTCONTAINERSUBTITLE"] = "Navigation";
elo.locale.localeMap["fr"]["APP.RIGHTCONTAINERSUBTITLE"] = "Aper\u00E7u";
elo.locale.localeMap["fr"]["APP.GOTO"] = "Basculer vers";
if (elo.data && elo.data.server && elo.data.server.language) {
elo.locale.language = elo.data.server.language;
elo.locale.store = elo.locale.localeMap[elo.locale.language];
}
return elo;
}));